<div>
  <ng-container *ngIf="errors$ | async as errors">
    <div class="command-error-message">
      Errors found:
      <ul>
        <li *ngFor="let error of errors">
          {{ error.message }}
        </li>
      </ul>
    </div>
  </ng-container>
  <fl-pilot-form #mfForm [pilot]="pilot"> </fl-pilot-form>
  <div *ngIf="transmissionInProgress" class="transmission-in-progress">
    Transmission in progress, this record cannot be updated.
  </div>
  <div fxLayout fxLayoutGap="10px">
    <button mat-raised-button (click)="update()" [disabled]="transmissionInProgress">Update</button>
    <a mat-button routerLink="..">Cancel</a> <span fxFlex fxFill></span>
    <button mat-raised-button (click)="delete()" color="warn">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  </div>
</div>
